import { arrayToEntityDict, type Entity, type EntityDict } from '../model'
import { postGetBody } from './api'

export async function ensureById<T extends Entity>(type: string, store: EntityDict<T>, ids: string[]): Promise<T[]> {
  const idsToLoad = [...new Set(ids)].filter(x => !(x in store))
  if (idsToLoad.length === 0) {
    return []
  }
  const response = await postGetBody<T[]>('documents-by-id', { type, ids: idsToLoad })
  if (!response) {
    return []
  }
  Object.assign(store, arrayToEntityDict(response))
  return response
}
